import { Translation } from "@jsverse/transloco";
import { VAR_NATIONAL_ID_LENGTH } from "../../../../shared/config/consts";

const rw: Translation = {
  citizen: {
    loginToContinue: "Injira kugirango ukomeze"
  },
  location: {
    province: "Intara",
    district: "Akarere",
    sector: "Umurenge",
    cell: "Akagari",
    village: "Umudugudu",
  },
  form: {
    title: {
      addCategory: "Ongeraho icyiciro",
      editCategory: "Hindura icyiciro",
      addAccount: "Umukozi mushya",
      editAccount: "Hindura umukozi",
      addInstitution: "Ikigo gishya",
      editInstitution: "Hindura ikigo",
      newCase: "Ikibazo gishya",
      editCase: "Hindura ikibazo",
      newAnnouncement: "Itangazo rishya",
      editAnnouncement: "Hindura itangazo",
      newCitizen: "Umuturage mushya",
      editCitizen: "Hindura umuturage",
      anonymousComplaint: "Ikibazo cy'ibanga",
      orientationLevel: 'Aho ibibazo bikurikiranwa',
    },
    label: {
      firstName: "Izina rya mbere",
      middleName: "Izina ryo hagati",
      lastName: "Izina rya nyuma",
      documentType: "Icyangombwa",
      documentNumber: "Nimero y'Icyangombwa",
      name: "Amazina",
      phoneNumber: "Telefoni",
      gender: "Igitsina",
      email: "Imeri",
      nationalId: "Indangamuntu",
      province: "Intara",
      district: "Akarere",
      sector: "Umurenge",
      cell: "Akagari",
      village: "Umudugudu",
      title: "Ikibazo",
      password: "Ijambo ry'ibanga",
      description: "Ubusobanuro",
      caseType: "Icyiciro cy'ikibazo",
      severity: "Uburemere",
      victimsNumber: "Abagize ikibazo",
      trackingLevel: "Urwego",
      estimateDays: "Igihe byatwara",
      primaryOrganization: "Ikigo gikurikirana ikibazo",
      informedOrganization: "Ibigo bimenyeshejwe ikibazo",
      issueLocation: "Aho Ikibazo cyabereye",
      issueDetails: "Ubusobanuro bw'ikibazo",
      orientationLevel: "Aho ibibazo bikurikiranwa",
      recordingLevel: "Urwego",
      complaint: "Ikibazo",
      goodGovernanceSection: "Ishami ry'imiyoborere myiza",
      search: "Shakisha",
      rejectionReason: "Impamvu ikibazo cyanzwe",
      optional: '(Singombwa)',
    },
    placeholder: {
      documentType: "Andika ubwoko bw'inyandiko",
      documentNumber: "Andika nomero y'inyandiko",
      name: "Andika amazina",
      phoneNumber: "Shyiramo nimero ya Telefoni",
      gender: "Hitamo",
      email: "Shyiramo Imeri",
      nationalId: "Shyiramo Indangamuntu",
      province: "Hitamo Intara",
      district: "Hitamo Akarere",
      sector: "Hitamo Umurenge",
      cell: "Hitamo Akagari",
      village: "Hitamo Umudugudu",
      title: "Andika Ikibazo",
      password: "Shyiramo Ijambo ry'Ibanga",
      complaint: "Shyiramo ikibazo cyose",
      description: "Shyiramo Ubusobanuro",
      caseType: "Hitamo ubwoko bw'ikibazo",
      severity: "Hitamo uburemere bw'ikibazo",
      victimsNumber: "Hitamo umubare wabagize ikibazo",
      trackingLevel: "Hitamo urwego rwo gukurikirana",
      estimateDays: "Injiza iminsi iteganijwe",
      primaryOrganization: "Hitamo ikigo nyamukuru",
      informedOrganization: "Hitamo ibigo byamenyeshejwe",
      issueLocation: "Injiza amakuru y'aho Ikibazo Cyabereye",
      issueDetails: "Injiza ibisobanuro by'ikibazo",
      orientationLevel: "Hitamo urwego rwo gukurikirana dosiye",
      recordingLevel: "Hitamo urwego rwo kwandika",
      searchInstitution: "Shakira aha",
      firstName: "Andika izina rya mbere",
      lastName: "Andika izina rya nyuma",
    },
    button: {
      forgotPassword: "Wibagiwe Ijambo ry'Ibanga?",
      login: "Injira",
      resetPassword: "Hindura Ijambo ry'Ibanga",
      alreadyHaveAnAccount: "Usanzwe ufite konti?",
      submitButton: "Ohereza",
      signUp: "Iyandikishe",
      ok: "Yego",
      cancel: "Hagarika",
      addCategory: "Ongeraho icyiciro",
      addAccount: "Ongeraho konti",
      addInstitution: "Ongeraho ikigo",
      newCase: "Ikibazo gishya",
      newAnnouncement: "Itangazo rishya",
      newCitizen: "Umuturage mushya",
      casesStatus: {
        closed: "Gifunge",
        ongoing: "Ikibazo Kirigukorwaho",
        done: "Gikemure Burundu",
        reopened: "Cyigarure",
      },
    },

    options: {
      severity: {
        low: 'Bidakabije',
        medium: 'Bigereranije',
        high: 'Bikomeye',
      },
      trackingLevel: {
        district: 'Akarere',
        sector: 'Umurenge',
        cell: 'Akagari',
        village: 'Umudugudu',
      },
      victimsNumber: {
        one: 'Umwe',
        multiple: 'Benshi',
      },
    },
    errors:{
      emailPhoneRequired:'Imeri / Nimero ya telefoni irakenewe',
      invalidEmailOrPhoneNumber: 'Imeri / nimero ya telefoni (07 XXXX XXXX) siyo',
      passwordRequired: "Ijambo ry'ibanga rirakenewe",
      firstIsRequired: "Izina rya mbere rirakenewe",
      lastIsRequired: "Izina rya nyuma rirakenewe",
      genderIsRequired: "Hitamo",
      nidIsRequired: `Nomero y'indangamuntu igomba kugira imibare ${VAR_NATIONAL_ID_LENGTH}`,
      phoneIsRequired: "Nimero ya telefoni (07 XXXX XXXX) irakenewe",
      codeRequired: "Kode yemeza irakenewe",
    }
  },
  resetPasswordForm: {
    title: "Hindura Ijambo ryawe ry'ibanga",
    description: "Shyiramo Ijambo ry'Ibanga rishya kugirango ukomeze ubone urubuga",
    label: {
      code: "Ijambo ry'ibanga rya kera",
      newPassword: "Ijambo ry'ibanga rishya",
    },
    placeholder: {
      code: "Andika Ijambo ry'ibanga rya kera",
      enterNewPassword: "Andika Ijambo ry'Ibanga rishya",
    },
    button: "Saba guhindura Ijambo ry'Ibanga",
  },
  casesStatus: {
    closed: "Cyakemutse",
    ongoing: "Kiri Gukorwaho",
    done: "Cyakemutse Burundu",
    reopened: "Cyagaruwe",
    pending: "Cyirategereje",
  },

  announcementStatus: {
    published: "Ryatangarijwe",
    unpublished: "Ryarangiye",
  },
  noCasesFound: 'Nta bibazo byabonetse',
  fetchingData: "Gushaka amakuru...",
  editPersonalInfo: "Amakuru Yawe",
  editPersonalInfoDescription: "Aya makuru akurwa ku ndangamuntu, ntiyahindurwa",
  changePassword: "Hindura Ijambo ry'Ibanga",
  changePasswordDescription: "Shyiramo ijambo ry'ibanga ukoreshaka kugira ngo urihindue",
  currentPassword: "Ijambo ry'Ibanga rya Kera",
  confirmPassword: "Emeza Ijambo ry'Ibanga",
  enterConfirmPassword: "Emeza Ijambo ry'Ibanga",
  enterCurrentPassword: "Shyiramo Ijambo ry'Ibanga rya Kera",
  // MENU
  dashboard: "Ibikubiyemo",
  complaints: "Ibyakiriwe",
  announcements: "Amatangazo",
  tipOffs: "Amakuru y'Ibanga",
  manage: "Gucunga",
  citizens: "Abaturage",
  institutions: "Ibigo",
  accounts: "Konti",
  security: "Umutekano",
  overview: "Incamake",
  cases: "Ibibazo",
  analytics: "Isesengura",
  staff: "Abakozi",
  rolesAndPermissions: "Inshingano n'Uburenganzira",
  systemSettings: "Igenamiterere rya Sisiteme",
  tipOffCategories: "Ibyiciro by'Amakuru y'Ibanga",

  tipOffCategoryPage: {
    title: "Ibyiciro by'Amakuru y'Ibanga",
    description: "Gucunga ibyiciro by'Amakuru y'Ibanga",
    action: {
      addNewCategory: "Ongeraho icyiciro",
    }
  },
  modal: {
    title: "Gushungura",
    byInstitution: "Hakurikijwe ikigo",
    clear: "Gusiba ibyo washunguye",
    apply: "Emeza ibyo washunguye",
    edit: "Hindura",
    view: "Reba",
    deactivate: "Hagarika",
    delete: "Siba",
  },
  home: "Ahabanza",
  landingPageTitle: "Ikaze kuri",
  noDocumentsFound: "Nta mpapuro zabonetse",
  myDashboard: "Urubuga rwanjye",
  reportAnonymously: "Tanga Ikibazo mw'Ibanga",
  quickOverview: "Amakuru y'ibanze",
  welcome: "Murakaza neza",
  tipOffCategory: "Icyiciro",
  tipOffCategoryPlaceholder: "Hitamo icyiciro",
  newAnonymousComplaint: "Tanga Ikibazo mw'Ibanga",
  issueDescription: "Ubusobanuro Bw'Ikibazo",
  enterIssueDescription: "Andika ubusobanuro bw'Ikibazo",
  issueTitlePlaceholder: "Andika Ikibazo",
  submitComplaint: "Tanga ikibazo",
  submitComplaintDescription: "Biragusaba konti kugira ngo utange ikibazo.",
  submitComplaintButton: "Tanga ikibazo",
  anonymousComplaintDescription: "Hano ntibisaba amakuru y'utanze ikibazo.",
  anonymousComplaintNoticeTitle: "Itangazo",
  anonymousComplaintNoticeMessage: "Ibibazo byatanzwe mu ibanga byakirwa ndetse bikanakemurwa n'ibigo bibishinzwe.Mbaza ntago ihamagara cyangwa ngo imenyeshe aho ikibazo kigeze uwatanze ikibazo mu ibanga. Niba ushaka kuzabona igisubizo cyangwa guhamagarwa, tanga ikibazo muburyo busanzwe.",
  newComplaint: "Ikibazo gishya",
  // cases: "Ibibazo",
  closed: "Ibyanzuwe",
  ongoing: "Ibigikorwaho",
  nationalId: "Indangamuntu",
  name: "Amazina",
  phoneNumber: "Nimero ya telefoni",
  gender: "Igitsina",
  email: "Imeri",
  complaintsAndCases: "Ibibazo",
  searchHere: "Shakisha hano",
  underReview: "Ibibazo bitarakorwaho / Ibyanzwe",
  myComplaints: "Ibibazo byanjye",
  statusOngoing: "Ibigikorwaho",
  statusPending: "Ibitarakorwaho",
  statusReOpened: "Ibyajuriwe",
  statusClosed: "Ibyanzuwe",
  statusDone: "Ibyakemutse",
  statusRejected: "Ibyanzwe",
  issueLocation: "Aho Ikibazo Cyabereye",
  district: "Akarere",
  sector: "Umurenge",
  cell: "Akagari",
  village: "Umudugudu",
  selectDistrict: "Hitamo akarere",
  selectSector: "Hitamo umurenge",
  selectCell: "Hitamo akagari",
  selectVillage: "Hitamo umudugudu",
  issueDetails: "Ubusobanuro bw'ikibazo",
  title: "Ikibazo",
  enterTitle: "Andika Ikibazo",
  complaint: "Ikibazo",
  complaintTitle: "Ikibazo",
  typeYourComplaint: "Andika Ikibazo Cyawe mu buryo burambuye",
  download: "Pakurura",
  noFilesAttached: "Nta madosiye yometse",
  complaintDetails: "Ubusobanuro bw'ikibazo",
  reportedOn: "Byatanzwe ku wa",
  close: "Funga",
  loading: "Biratangurirwa...",
  supportingAttachments: "Inyandiko n'Ibimenyetso",
  caseDetails: "Ubusobanuro bw'ikibazo",
  reportedBy: "Byatanzwe na",
  informedInstitutions: "Ibigo byamenyeshejwe",
  noOrganizationsInformed: "Nta bigo byamenyeshejwe",
  caseTimeline: "Igihe cy'ikibazo",
  tracking: "Kurikirana",
  trackingPlaceholder: "Andika code y'ikibazo",
  trackingLevel: "Urwego rw'ikurikirana",
  createdBy: "Byakozwe na",
  assignedTo: "Byahawe",
  primaryOrganization: "Ikigo cy'ibanze",
  none: "Nta na kimwe",
  myProfile: "Umwirondoro wanjye",
  profile: "Umwirondoro",
  logout: "Sohoka",
  login: "Injira",
  register: "Kwiyandikisha",
  trackComplaint: "Kurikirana ikibazo",
  trackAnotherComplaint: "Kurikirana ikindi kibazo",
  reportedAComplaint: "Yatanze ikibazo",
  createdACase: "Yakoze ikibazo",
  addedAComment: "Yongeyeho igitekerezo",
  trackYourComplaint: "Kurikirana ikibazo cyawe",
  mostCasePerDistrict: "Uturere dufite ibibazo byinshi",
  mostCasePerInstitution: "Ibigo bifite ibibazo byinshi",
  mostCasePerCategory: "Ibyiciro bifite ibibazo byinshi",
  mostCasePerChannel: 'Uburyo bwakoreshejwe',
  caseTrendThisYear: "Uko ibibazo byahindutse muri uyu mwaka",
  notifications: "Amakuru mashya",
  newCase: "Ikibazo gishya",
  createCase: "Kora ikibazo",
  nonOrientedComplaints: "Ibibazo bitayoborwa",
  filterComplaints: "Shuza ibibazo",
  today: "Uyu munsi",
  thisWeek: "Iki cyumweru",
  thisMonth: "Uku kwezi",
  thisYear: "Uyu mwaka",
  allTime: "Igihe cyose",
  enterNamesKeyword: "Andika amazina, Ijambo...",
  retry: "Ongera ugerageze",
  urgentCases: "Ibyihutirwa",
  nothingToShow: "Nta kintu cyo kwerekana",
  thisListIsEmpty: "Urutonde rusa",
  filter: "Shuza",
  allCases: "Ibibazo byose",
  selectStatus: "Hitamo imimerere",
  selectCategory: "Hitamo icyiciro",
  selectOwnership: "Hitamo uwubifitemo",
  primaryCases: "Ibibazo by'ibanze",
  secondaryCases: "Ibibazo bya kabiri",
  status: "Imimerere",
  type: "Ubwoko",
  filterCases: "Shuza ibibazo",
  byLocation: "Hakurikijwe ahantu",
  byInstitutions: "Hakurikijwe ibigo",
  bySeverityAndUrgency: "Hakurikijwe Uburemere",
  institution: "Ikigo",
  severity: "Uburemere",
  urgency: "Ubwihuse",
  ownership: " Uwubifitemo",
  allStatus: "Imimerere yose",
  allTypes: "Ubwoko bwose",
  allOwnerships: "Abafite byose",
  allDistricts: "Uturere twose",
  allSectors: "Imirenge yose",
  allCells: "Utugari twose",
  allVillages: "Imidugudu yose",
  allInstitutions: "Ibigo byose",
  allSeverities: "Ubukomeye bwose",
  allUrgencies: "Ubwihuse bwose",
  clearFilters: "Kuraho ishuza",
  filterList: "Urutonde rw'ishuza",
  dateRange: "Igihe",
  period: "Igihe",
  selectHere: "Hitamo hano",
  mostCasesPerCategory: "Ibyiciro bifite ibibazo byinshi",
  mostCasesPerInstitutions: "Ibigo bifite ibibazo byinshi",
  mostCasesPerDistrict: "Uturere dufite ibibazo byinshi",
  noDataAvailable: "Nta makuru aboneka",
  totalCases: "Ibibazo byose",
  new: "Gishya",
  reopened: "Ibyajuriwe",
  avgReactionTime: "Igihe cyo gusubiza",
  avgSatisfaction: "Ibyishimye",
  done: "Ibyakemutse",
  casesTrendPerYear: "Uko ibibazo byahindutse mu mwaka",
  casesOnTheMap: "Aho ibibazo biherereye",
  totalCitizens: "Abaturage bose",
  withOngoingCases: "Bafite ibibazo bikiri Gukorwaho",
  avgCasesPerUser: "Ibibazo ku mukoresha",
  avgCasesPerInstitution: "Ibibazo ku mukoresha ku ikigo",
  female: "Gore",
  male: "Gabo",
  foreigners: "Abanyamahanga",
  newCitizen: "Umuturage mushya",
  createCitizen: "Kora umuturage",
  saveChanges: "Emeza",
  editCitizen: "Hindura umuturage",
  numberOfCases: "Umubare w'ibibazo",
  totalInstitutions: "Ibigo byose",
  institutionsWithOngoingCases: "Ibigo bifite Ibibazo bikiri Gukorwaho",
  newInstitution: "Ikigo gishya",
  addInstitution: "Ongeraho ikigo",
  //TODO THIS
  ongoingCases: "Ibigikorwaho",
  closedCases: "Ibibazo byakemutse",
  resolvedCases: "Ibibazo byakemutse burundu",
  reOpenedCases: "Ibibazo byagaruwe",
  joined: "Yinjiye",
  myCases: "Ibibazo byanjye",
  taggedCases: "Ibibazo byashyizweho ikimenyetso",
  organizationDetails: "Ibisobanuro by'ikigo",
  performance: "Imikorere",
  admin: "Umuyobozi",
  addStaff: "Ongeraho umukozi",
  newStaff: "Umukozi mushya",
  systemAccounts: "Konti za sisitemu",
  role: "Inshingano",
  lastLogin: "Ubwa nyuma kwinjira",
  edit: "Hindura",
  addAccount: "Ongeraho konti",
  addRole: "Ongeraho inshingano",
  usedBy: "Ikoreshwa na",
  roles: "Inshingano",
  newRole: "Inshingano nshya",
  newAnnouncement: "Itangazo rishya",
  unpublish: "Kuraho itangazo",
  expiresAt: "Rizarangira ku wa",
  announcementTitle: "Incamake ry'Itangazo",
  announcement: "Itangazo",
  announcementValidity: "Igihe itangazo rizamara",
  expiryDate: "Itariki rizarangira",
  publishAnnouncement: "Tanga itangazo",
  yourAnnouncement: "Itangazo ryawe",
  announcementValidityDescription: "Iki ni gihe itangazo rizakora, niba ritashyizweho rizamara iminsi 5 kuva ritangarijwe",
  published: "Ryatangarijwe",
  unpublished: "Ryarangiye",
  reviewComplaint: "Tanga igitekerezo ku mwanzuro w'ikibazo",
  rating: "Ikigero",
  commentsOptional: "Igitekerezo (Ni amahitamo)",
  shareYourFeedback: "Andika igitekerezo cyawe...",
  reporterReview: "Igitekerezo cy'umuturage",
  enterNationalId: "Andika Indangamuntu",
  continue: "Komeza",
  haveAnAccount: "Usanzwe ufite konti?",
  selectYourPhoneNumber: "Hitamo nimero ya telefoni",
  associatedPhoneNumbers: "Nimero zihuje n' indangamuntu yawe",
  requestVerificationCode: "Saba kode",
  verificationCode: "Kode yoherejwe",
  verificationCodeDescription: "Woherejwe kode kuri nimero {{ phone }}",
  verifyCode: "Ohereza kode",
  completeYourRegistration: "Komeza kwiyandikisha",
  completeRegistrationDescription: "Injiza imeri n'Ijambo ry'Ibanga kugirango wiyandikishe",
  firstName: "Izina rya mbere",
  lastName: "Izina rya kabiri",
  enterEmail: "Andika imeri",
  password: "Ijambo ry'ibanga",
  enterPassword: "Andika Ijambo ry'Ibanga",
  signUp: "Kwiyandikisha",
  emailOrPhone: "Imeri / Telephone",
  enterEmailOrPhoneNumber: "Andika imeri cyangwa nimero ya telefoni",
  forgotPassword: "Wibagiwe Ijambo ry'ibanga?",
  resetPassword: "Hindura Ijambo ry'Ibanga",
  goToLogin: "Kwinjira",
  code: "Code",
  enterCode: "Andika code",
  newPassword: "Ijambo ry'ibanga rishya",
  enterNewPassword: "Andika Ijambo ry'Ibanga rishya",
  confirmPasswordReset: "Emeza Ijambo ry'Ibanga rishya",
  noNotificationsFound: "Nta makuru mashya",
  selectInstitution: "Hitamo ikigo",
  manageCaseCategoriesDescription: "Gushyiramo icyiciro cy'ibibazo n'amakuru yaho.",
  caseCategories: "Ibyiciro by'ikibazo",
  addCaseCategory: "Ongeraho icyiciro cy'ibibazo",
  updateCaseCategory: "Hindura icyiciro cy'ibibazo",
  deleteCaseCategory: "Siba icyiciro cy'ikibazo",
  caseCategoryName: "Amazina y' icyiciro cy'ikibazo",
  caseCategoryDescription: "Amakuru ya icyiciro cy'ikibazo",
  enterCaseCategoryName: "Andika amazina ya icyiciro cy'ikibazo",
  enterCaseCategoryDescription: "Andika ubusobanuro bw'icyiciro cy'ikibazo",
  editAnnouncement: "Hindura itangazo",
  tipoffs: "Amakuru y'Ibanga",
  institutionCases: "Ibibazo ku kigo",
  permissions: "Inshingano n'Uburenganzira",
  caseCategoriesSettings: "Ibyiciro by'ikibazo",
  createdAt: "Byakozwe ku itariki",
  description: "Ubusobanuro",
  refreshAnalytics: "Jyanisha isesengura",
  analyticsRefreshed: "Kujyanisha isesengura byagenze neza",
  errorRefreshingAnalytics: "Kujyanisha isesengura ntibyakunze",
  organization: "Ikigo",
  occupation: "Umwanya",
  private: "Ibanga",
  noTimestamp: "Nta gihe cyashyizweho",
  theCaseWasMarkedAs: "Ikibazo cyagizwe",
  theCaseWasEscalatedTo: "Ikibazo cyazamuriwe urwego",
  escalatedTheCaseTo: "Cyazamuwe ku",
  complaintType: "Ubwoko bw'ikibazo",
  casesOverview: 'Incamake',
  systemConfiguration: {
    title: 'Ni gute wifuza kwakira amatangazo',
    description: 'Hindura uburyo bwo kwakira amatangazo',
    label: 'Igenamiterere rya sisitemu',
  },
  EAST:"IBURASIRAZUBA",
  WEST:"IBURENGERAZUBA",
  NORTH:"AMAJYARUGURU",
  SOUTH:"AMAJYEPFO",
  KIGALI: "KIGALI",
  verifyComplaint: "Gusuzuma Ikibazo",
  verify:'Suzuma',
  verifyUser: "Emeza umukoresha",
  verifyUserDescription: "Twohereje kode yo kwemeza kuri telefone yawe",
  provinceIsRequired: "Intara irakenewe",
  districtIsRequired: "Akarere karakenewe",
  sectorIsRequired: "Umurenge urakenewe",
  cellIsRequired: "Akagari karakenewe",
  villageIsRequired: "Umudugudu urakenewe",
  titleIsRequired: "Ikibazo kirakenewe",
  titleMaxLength: "Ikibazo ntikigomba kurenza inyuguti 250",
  complaintIsRequired: "Ubusobanuro bw'ikibazo burakenewe",
  tipOffCategoryIsRequired: "Icyiciro cy'ikibazo kirakenewe",
  caseNotFound: 'Ikibazo cyanyu cyakiriwe kiri gusuzumwa',
  goToHome: 'Subira ahabanza',
  trackComplaintNumber: 'Kurikirana ikibazo #',
  noComplaintCode: "Nta kode y'ikibazo yatanzwe",
  verificationCodeSentTo: 'Kode yo kwemeza yoherejwe neza kuri',
  success: "Byakunze",
  toast: {
    error: "Ikosa",
    success: "Byakunze",
    clipboard: "Nomero y'ikibazo yafotowe"
  },
  menu: "Menu"
};

export default rw;
